export default {
    categories: [],
    selected_category: {
        type: Object,
        default: () => ({}),
    },
};